import React from 'react';

export const SIGNUP_STEPS = ['Seus dados', 'Placa', 'Veículo', 'Confirmação'];

// Etapas do cadastro (ou de outro wizard): barra segmentada e "Etapa N de M", legivel ja no celular.
export default function ProgressBarComponent({ step, steps = SIGNUP_STEPS }) {
  const total = steps.length;

  return (
    <div className="signup-steps">
      <p className="signup-steps-label" aria-live="polite">
        Etapa {step} de {total}
        <span> · {steps[step - 1]}</span>
      </p>
      <ol className="signup-steps-bar" aria-hidden="true" style={{ gridTemplateColumns: `repeat(${total}, 1fr)` }}>
        {steps.map((label, index) => (
          <li
            key={label}
            className={index + 1 <= step ? 'is-done' : ''}
            title={label}
          />
        ))}
      </ol>
    </div>
  );
}
